module.exports = __webpack_public_path__ + "static/img/证书.972b462.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/about/证书.jpg
// module id = sOXe
// module chunks = 1